import { getFileWithAccessDatasets, getFileWithAcr, getReferencedPolicyUrlAll, getResourceInfoWithAccessDatasets, getResourceInfoWithAcr, getSolidDatasetWithAccessDatasets, getSolidDatasetWithAcr, hasAccessibleAcr, saveAcrFor } from './acp.mjs';
import { acrAsMarkdown, addAcrPolicyUrl, addMemberAcrPolicyUrl, addMemberPolicyUrl, addPolicyUrl, getAcrPolicyUrlAll, getMemberAcrPolicyUrlAll, getMemberPolicyUrlAll, getPolicyUrlAll, hasLinkedAcr, removeAcrPolicyUrl, removeAcrPolicyUrlAll, removeMemberAcrPolicyUrl, removeMemberAcrPolicyUrlAll, removeMemberPolicyUrl, removeMemberPolicyUrlAll, removePolicyUrl, removePolicyUrlAll } from './control.mjs';
import { createPolicy, getAllowModesV1, getDenyModesV1, getPolicy, getPolicyAll, policyAsMarkdown, removePolicy, setAllowModesV1, setDenyModesV1, setPolicy } from './policy.mjs';
import { addAgent, addNoneOfRuleUrl, addGroup, addAnyOfRuleUrl, addAllOfRuleUrl, createRule, getAgentAll, getNoneOfRuleUrlAll, getGroupAll, getAnyOfRuleUrlAll, getAllOfRuleUrlAll, getRule, getRuleAll, hasAuthenticated, hasCreator, hasPublic, removeAgent, removeNoneOfRuleUrl, removeGroup, removeAnyOfRuleUrl, removeAllOfRuleUrl, removeRule, ruleAsMarkdown, setAgent, setNoneOfRuleUrl, setGroup, setAnyOfRuleUrl, setAllOfRuleUrl, setRule, setPublic, removePublic, setAuthenticated, removeAuthenticated, setCreator, removeCreator } from './rule.mjs';
import { addMockAcrTo, mockAcrFor } from './mock.mjs';

//
const v2AcpFunctions = {
    getFileWithAccessDatasets,
    getFileWithAcr,
    getReferencedPolicyUrlAll,
    getResourceInfoWithAccessDatasets,
    getResourceInfoWithAcr,
    getSolidDatasetWithAccessDatasets,
    getSolidDatasetWithAcr,
    hasAccessibleAcr,
    saveAcrFor,
};
const v2ControlFunctions = {
    acrAsMarkdown,
    addAcrPolicyUrl,
    addMemberAcrPolicyUrl,
    addMemberPolicyUrl,
    addPolicyUrl,
    getAcrPolicyUrlAll,
    getMemberAcrPolicyUrlAll,
    getMemberPolicyUrlAll,
    getPolicyUrlAll,
    hasLinkedAcr,
    removeAcrPolicyUrl,
    removeAcrPolicyUrlAll,
    removeMemberAcrPolicyUrl,
    removeMemberAcrPolicyUrlAll,
    removeMemberPolicyUrl,
    removeMemberPolicyUrlAll,
    removePolicyUrl,
    removePolicyUrlAll,
};
const v2PolicyFunctions = {
    createPolicy,
    getAllowModes: getAllowModesV1,
    getDenyModes: getDenyModesV1,
    getPolicy,
    getPolicyAll,
    policyAsMarkdown,
    removePolicy,
    setAllowModes: setAllowModesV1,
    setDenyModes: setDenyModesV1,
    setPolicy,
};
const v2RuleFunctions = {
    addAgent,
    addForbiddenRuleUrl: addNoneOfRuleUrl,
    addGroup,
    addOptionalRuleUrl: addAnyOfRuleUrl,
    addRequiredRuleUrl: addAllOfRuleUrl,
    createRule,
    getAgentAll,
    getForbiddenRuleUrlAll: getNoneOfRuleUrlAll,
    getGroupAll,
    getOptionalRuleUrlAll: getAnyOfRuleUrlAll,
    getRequiredRuleUrlAll: getAllOfRuleUrlAll,
    getRule,
    getRuleAll,
    hasAuthenticated,
    hasCreator,
    hasPublic,
    removeAgent,
    removeForbiddenRuleUrl: removeNoneOfRuleUrl,
    removeGroup,
    removeOptionalRuleUrl: removeAnyOfRuleUrl,
    removeRequiredRuleUrl: removeAllOfRuleUrl,
    removeRule,
    ruleAsMarkdown,
    setAgent,
    setForbiddenRuleUrl: setNoneOfRuleUrl,
    setGroup,
    setOptionalRuleUrl: setAnyOfRuleUrl,
    setRequiredRuleUrl: setAllOfRuleUrl,
    setRule,
};
const v2MockFunctions = {
    addMockAcrTo,
    mockAcrFor,
};
/* istanbul ignore next Not a supported public API: */
/** @deprecated Replaced by [[setPublic]] */
function previousSetPublicSignature(rule, enable) {
    return enable ? setPublic(rule) : removePublic(rule);
}
/* istanbul ignore next Not a supported public API: */
/** @deprecated Replaced by [[setAuthenticated]] */
function previousSetAuthenticatedSignature(rule, enable) {
    return enable ? setAuthenticated(rule) : removeAuthenticated(rule);
}
/* istanbul ignore next Not a supported public API: */
/** @deprecated Replaced by [[setCreator]] */
function previousSetCreatorSignature(rule, enable) {
    return enable ? setCreator(rule) : removeCreator(rule);
}
const deprecatedFunctions = {
    /** @deprecated This misspelling was included accidentally. The correct function is [[getForbiddenRuleUrlAll]]. */
    getForbiddenRuleurlAll: getNoneOfRuleUrlAll,
    setPublic: previousSetPublicSignature,
    setAuthenticated: previousSetAuthenticatedSignature,
    setCreator: previousSetCreatorSignature,
};
/**
 * @hidden
 * @deprecated Replaced by [[acp_v3]].
 */
const acp_v2 = {
    ...v2AcpFunctions,
    ...v2ControlFunctions,
    ...v2PolicyFunctions,
    ...v2RuleFunctions,
    ...v2MockFunctions,
    ...deprecatedFunctions,
};

export { acp_v2, previousSetAuthenticatedSignature, previousSetCreatorSignature, previousSetPublicSignature };
